import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const CobieIcon = ({ color = '#fbb07e', text = 'COBIE' }) => (
  <BaseFileIcon color={color} text={text} fontSize="6" />
);

export default CobieIcon;
